import { SuccessReturnBody, getSuccessReturnBody } from '../general';
import { Brand, Carac, MasterDataEquipment, Sheet, SheetCarac } from '../../types/noocoDbTypes';
import { CaracCombo, IndexWithSheetIndex } from '../../types/noocoTypes';
import { CaracWithSheetCarac } from '../../types/other/sheetWithCaracs';

export interface CaracsByAllotmentNodeGetRequest {
	AllotmentNodeId: number;
	ProjectSheetId?: number;
	fetchSheets?: boolean;
}

export type MasterDataEquipmentReduced = Pick<MasterDataEquipment, 'id' | 'unit' | 'xAxisId' | 'discreteId' | 'secondDiscreteId' | 'isConfiguredSheetImportAllowed' | 'hasFluid'>;

export interface SheetExtended extends Sheet {
	Brand: Brand; 
	Carac: CaracWithSheetCarac[];
	Index: IndexWithSheetIndex[];
  }

export interface CaracsByAllotmentNode extends MasterDataEquipmentReduced {
	caracs: Carac[];
	AllotmentNodeId: number;
	sheets?: SheetExtended[];
	caracCombos: CaracCombo;
	projectSheetCaracs?: {
		ProjectSheetId: number;
		caracs: Pick<SheetCarac, "CaracId" | "value">[]
	};
}

export const serverErrorReturnMessage = "Missing information";

export function getCaracsByAllotmentNodeSuccess(caracsByAllotmentNode: CaracsByAllotmentNode): SuccessReturnBody {
  return getSuccessReturnBody(caracsByAllotmentNode);
}
